import { SET_CURRENT_SLIDE } from "../actions";
import initialState from "./initialState";
export default function currentSlide() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.currentSlide, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SET_CURRENT_SLIDE:
            return action.id;
        default:
            return state;
    }
}
